import React, { useMemo, useState } from "react";
import { Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";

const GenesysCloudCredentials = () => {
  const location = useLocation();

  const sentimentData = useMemo(() => {
    try {
      const raw =
        location.state?.sentimentData ||
        localStorage.getItem("UISentimentAnalysisMetrics") ||
        "[]";

      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      const records =
        typeof parsed.body === "string" ? JSON.parse(parsed.body) : parsed.body;

      const userMap = {};
      (Array.isArray(records) ? records : []).forEach((entry) => {
        const participant = entry.Transcript?.[0];
        const user = participant?.ParticipantId || "Unknown User";

        if (!userMap[user]) userMap[user] = [];

        userMap[user].push({
          Date: new Date(
            entry.CustomerMetadata.InitiationTimestamp
          ).toLocaleString(),
          Role: participant?.ParticipantRole || "N/A",
          Direction: entry.CustomerMetadata.Channel || "N/A",
          Queue: entry.CustomerMetadata.Queue || "N/A",
          SentimentScore:
            entry.ConversationCharacteristics.CustomerSentiment || "N/A",
          SentimentTrend:
            entry.ConversationCharacteristics.SentimentTrend?.map(
              (t) => `${t.Sentiment} at ${new Date(t.Time).toLocaleString()}`
            ).join(", ") || "No data",
        });
      });

      return userMap;
    } catch (err) {
      console.error("Failed to parse sentiment data:", err);
      return {};
    }
  }, [location]);

  const [selectedUser, setSelectedUser] = useState(null);

  const handleUserClick = (userName) => {
    setSelectedUser(userName === selectedUser ? null : userName);
  };

  return (
    <MainTheme>
      <Title title="Sentiment Metrics" />
      <div className="organization-details-section">
        <Grid container spacing={2} className="container-section">
          <Grid item xs={12}>
            {Object.keys(sentimentData).length === 0 ? (
              <p>No sentiment data available.</p>
            ) : (
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  alignItems: "flex-start",
                }}
              >
                {/* Left side - User list */}
                <div
                  style={{
                    width: "220px",
                    maxHeight: "320px", // ~7 buttons tall
                    overflowY: "auto",
                    overflowX: "hidden",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <h3 style={{ marginTop: 0 }}>Users</h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {Object.keys(sentimentData).map((user) => (
                      <li key={user} style={{ marginBottom: "10px" }}>
                        <div
                          onClick={() => handleUserClick(user)}
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            backgroundColor:
                              user === selectedUser ? "#e0e0e0" : "#f5f5f5",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                            textAlign: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {user}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Right side - Metrics table */}
                <div style={{ flex: 1 }}>
                  {selectedUser ? (
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        maxHeight: "320px",
                        overflowY: "auto",
                      }}
                    >
                      <h3 style={{ marginTop: 0 }}>{selectedUser} Metrics</h3>
                      {sentimentData[selectedUser].map((entry, idx) => (
                        <table
                          key={idx}
                          style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            marginBottom: "15px",
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "6px",
                                  backgroundColor: "#f0f0f0",
                                  position: "sticky",
                                  top: 0,
                                  width: "150px",
                                }}
                              >
                                Metric
                              </th>
                              <th
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "6px",
                                  backgroundColor: "#f0f0f0",
                                  position: "sticky",
                                  top: 0,
                                }}
                              >
                                Value
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(entry).map(([metric, value]) => (
                              <tr key={metric}>
                                <td
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "6px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {metric}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "6px",
                                  }}
                                >
                                  {value}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ))}
                    </div>
                  ) : (
                    <p>Select a user to view their sentiment metrics.</p>
                  )}
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </MainTheme>
  );
};

export default GenesysCloudCredentials;
